import React from 'react';
import PropTypes from 'prop-types';

import { BookingConfirmationMenuItem } from 'v1/components/shared';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger
} from 'v5/design-system/DropdownMenu.js';
import { Zap } from 'lucide-react';
import { Button } from 'v5/design-system/Button.js';

const BookingActions = ({ bookingId }) => {
  // Note: Toast handling moved to BookingConfirmationMenuItem component
  // using sendBookingConfirmationWithToast helper to avoid duplicate listeners

  return (
    <div className="tailwind-root contents">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" size="sm" layout="icon">
            <Zap />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <BookingConfirmationMenuItem bookingId={bookingId} />
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

BookingActions.propTypes = {
  bookingId: PropTypes.number
};

export default BookingActions;
